import { render, staticRenderFns } from "./reminders-view.vue?vue&type=template&id=d1451740&"
import script from "./reminders-view.vue?vue&type=script&lang=ts&"
export * from "./reminders-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports